import React from "react";
import { Link } from "react-scroll";

const About = () => {
  return (
    <div
      name="a propos"
      className="w-full h-fit sm:pb-60 bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500  ">
            A propos
          </p>
        </div>
        <p className="text-xl mt-20">
          Passionné par le développement informatique depuis le collège, où j’ai
          écrit mes premières lignes de code en Python, j’ai naturellement
          orienté mon parcours scolaire vers ce domaine afin de mieux le
          découvrir et m’y investir professionnellement.
        </p>
        <br />
        <p className="text-xl">
          J’ai récemment validé ma Licence 3 MIAGE en alternance chez{" "}
          <b>
            {" "}
            <Link to="alternance" smooth duration={500}>
              <b>
                {" "}
                <u>TimActive</u>
              </b>
            </Link>
          </b>
          , une expérience qui m’a permis de consolider mes compétences
          techniques et professionnelles. Je poursuis actuellement mes études en{" "}
          <b>Master MIAGE</b> afin d’approfondir mes connaissances en ingénierie
          logicielle, gestion de projet et technologies avancées.
        </p>
        <br />

        <p className="text-xl">
          Ma formation ainsi que mon alternance m'ont permis de développer mes
          compétences en programmation web/métier ainsi qu'en gestion de projet
          à travers de nombreux TP et projets. Vous pouvez retrouver les
          technologies que j'ai apprises{" "}
          <Link to="technologies" smooth duration={500}>
            <b>
              {" "}
              <u>ici</u>
            </b>
          </Link>
        </p>
        <div className="mt-6 p-4 bg-gray-700 bg-opacity-50 border-l-4 border-purple-500 rounded-md">
          <div className="flex items-start">
            <svg
              className="w-6 h-6 text-purple-400 mr-3 mt-1"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M7.17 6.17C5.95 7.39 5 9.12 5 11v2a2 2 0 002 2h2v-2H7v-2c0-1.3.52-2.4 1.17-3.07A4 4 0 0010 6H8a4 4 0 00-.83.17zM17.17 6.17C15.95 7.39 15 9.12 15 11v2a2 2 0 002 2h2v-2h-2v-2c0-1.3.52-2.4 1.17-3.07A4 4 0 0020 6h-2a4 4 0 00-.83.17z" />
            </svg>
            <div>
              <p className="text-gray-300 italic text-base">
                « Grâce à son profil full-stack solide, son sens aigu de la
                collaboration et sa capacité à communiquer efficacement, M.
                Yanis Benlalam apportera une valeur immédiate et durable à toute
                organisation recherchant un développeur rigoureux, autonome et
                orienté solution. »
              </p>
              <p className="text-sm text-gray-400 mt-2">
                — Romain De Véra, CEO de TimActive, tuteur alternance 2024-2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
